// TODO: update any to be a union of possible site list types when
//       the site id type in v3 site list is updated to be compatible (string | number | undefined).
//       currently v3 site id is only string | undefined.
export const removeDeletedSites = (sites?: any[]) =>
  sites?.filter((site: any) => !site?.status?.includes('deleted'));
